import { DatePipe } from '@angular/common';
import { Component, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  BaseResourceListComponent, Coluna, DateFormatPipe, Filtro, FormatoExportacao, GlobalService, LoginPublico, Pagamento
} from 'eddydata-lib';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PagamentoService } from '../service/pagamento.service';

@Component({
  selector: 'app-pagamento-lst',
  templateUrl: './pagamento-lst.component.html'
})
export class PagamentoLstComponent extends BaseResourceListComponent<Pagamento, LoginPublico> {

  /**
   * Declaração de variáveis
   */
  public ptBR: any;
  public data1: Date;
  public data2: Date;
  protected datepipe: DatePipe;

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    private route: ActivatedRoute,
    protected injector: Injector,
    private globalService: GlobalService,
    private pagamentoService: PagamentoService) {
    super(pagamentoService, injector);
    this.route.params.pipe(takeUntil(this.unsubscribe))
      .subscribe(params => {
        this.data1 = new DateFormatPipe().transform(params['data1'], []);
        this.data2 = new DateFormatPipe().transform(params['data2'], []);
        this.paginaCorrente = +params['pagina'];
        this.filtro = params['filtro'];
      });
  }


  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected relations(): string {
    return 'conta,liquidacao,liquidacao.empenho,liquidacao.empenho.favorecido,liquidacao.empenho.ficha,'
      + 'liquidacao.empenho.ficha.acao,exercicio,orgao';
  }

  protected condicoesGrid(): {} {
    return {
      ['orgao.id']: this.login.orgao.id,
    };
  }

  protected ordenacaoGrid(): string[] {
    return ['id$ASC'];
  }

  protected filtrosGrid(): Filtro {
    return {};
  }

  public beforeInit(): void {
    this.login.contraste = sessionStorage.getItem('contraste') === 'true';
    if (this.login.exercicio && !this.data1) {
      this.data1 = new Date(`01/01/${this.login.exercicio.ano}`);
      if (this.login.exercicio.ano !== new Date().getFullYear()) {
        this.data2 = new Date(`12/31/${this.login.exercicio.ano}`);
      }
    }
    this.col = 2;
  }

  protected afterInit(): void {
    window.scrollTo(0, 0);
    this.datepipe = new DatePipe('pt');
    this.ptBR = this.globalService.obterDataBR();
  }

  protected acaoRemover(model: Pagamento): Observable<Pagamento> {
    return null;
  }

  public obterParametros() {
    const parametros = {};
    this.datepipe = new DatePipe('pt');
    parametros['ignoreCondObrig'] = true;
    parametros['data_pagamento$ge'] = this.datepipe.transform(this.data1, 'yyyy-MM-dd');
    parametros['data_pagamento$le'] = this.datepipe.transform(this.data2, 'yyyy-MM-dd');
    parametros['orgao.id'] = this.login.orgao.id;
    parametros['relations'] = 'conta,liquidacao,liquidacao.empenho,liquidacao.empenho.favorecido,liquidacao.empenho.ficha,'
      + 'liquidacao.empenho.ficha.acao,exercicio,orgao';
    if (this.filtro) {
      parametros['OR'] =
        // tslint:disable-next-line: max-line-length
        `liquidacao.empenho.favorecido.nome$like=${this.filtro}%;!;!;liquidacao.empenho.numero=${this.filtro};!;!;conta.numero_conta$like=${this.filtro}%;!;!;valor_pago=${this.filtro.replace(',', '.')}`;
    }
    switch (this.col) {
      case 1:
        parametros['orderBy'] = `liquidacao.empenho.numero$${this.ascendente ? 'ASC' : 'DESC'}`;
        break;
      case 2:
        parametros['orderBy'] = `data_pagamento$${this.ascendente ? 'ASC' : 'DESC'}`;
        break;
      case 3:
        parametros['orderBy'] = `liquidacao.empenho.favorecido.nome$${this.ascendente ? 'ASC' : 'DESC'}`;
        break;
      case 4:
        parametros['orderBy'] = `conta.numero_conta$${this.ascendente ? 'ASC' : 'DESC'}`;
        break;
      case 5:
        parametros['orderBy'] = `valor_pago$${this.ascendente ? 'ASC' : 'DESC'}`;
        break;
      default:
        break;
    }
    return parametros;
  }

  public preencherGrid() {
    const parametros = this.obterParametros();
    this.pagamentoService
      .filtrar(
        this.paginaCorrente,
        this.login.limite,
        parametros
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        lista => {
          this.lista = lista.content;
          this.paginaTotal = lista.totalPages;
        },
        () => alert('erro ao retornar lista')
      );
  }


  protected colunasRelatorio(): string[] | Coluna[] {
    return [
      { titulo: 'Data', coluna: 'data_pagamento' },
      { titulo: 'Número', coluna: 'liquidacao.empenho.numero' },
      { titulo: 'Fornecedor/credor', coluna: 'liquidacao.empenho.favorecido.nome' },
      { titulo: 'Agência nome', coluna: 'conta.agencia_nome' },
      { titulo: 'Número conta', coluna: 'conta.numero_conta' },
      { titulo: 'Valor', coluna: 'valor_pago', decimais: 2, alignment: 'right' }
    ];
  }

  public exportarListagem(formato: FormatoExportacao) {
    const parametros = this.obterParametros();
    this.pagamentoService
      .filtrar(1, -1,
        parametros
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        lista => {
          if (formato === 'pdf') {
            this.imprimir('LISTAGEM DE PAGAMENTOS ORÇAMENTÁRIOS',
              '', '', this.login.orgao.nome, this.login.brasao, 'portrait',
              'Listagem pagamentos', ['auto', 'auto', '*', 'auto', 'auto', 'auto'], lista.content, ['valor_pago']);
          } else {
            this.exportar(formato, lista.content);
          }
        },
        () => alert('erro ao retornar lista')
      );
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  public editar(id: number) {
    const dt1 = this.datepipe.transform(this.data1, 'yyyy-MM-dd', 'GMT');
    const dt2 = this.datepipe.transform(this.data2, 'yyyy-MM-dd', 'GMT');
    if (!this.filtro || this.filtro === '') {
      this.router.navigate([
        '/pagamentos-orcamentarios/visualiza', id, this.paginaCorrente, dt1, dt2]);
    } else {
      this.router.navigate([
        '/pagamentos-orcamentarios/visualiza', id, this.paginaCorrente, dt1, dt2, this.filtro]);
    }
  }

  public onSelectPeriodo() {
    this.preencherGrid();
  }

}
